/* eslint-disable no-useless-escape */
import { head } from 'lodash'
import isURL from 'validator/lib/isURL'
import { cdnHelper } from './cdn'

function isJsonString(text) {
  return /^[\],:{}\s]*$/.test(
    text
      .replace(/\\["\\\/bfnrtu]/g, '@')
      .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
      .replace(/(?:^|:|,)(?:\s*\[)+/g, '')
  )
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replace)
}

function getLinkFromString(str) {
  if (!str) return null
  const link = str.match(/(https?:\/\/[^\s]+)/g)
  return link ? head(link) : null
}

function addUrl(str) {
  if (!str) return ''
  if (isURL(str)) {
    return str
  }
  return cdnHelper.getFileUrl(str)
}

export const stringHelper = {
  replaceAll,
  isJsonString,
  getLinkFromString,
  addUrl,
}
